module.exports = __webpack_public_path__ + "static/media/chat_guide.78b30780.png";